/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { getColor, pd } from '@airasia-phoenix/react-native/utils/utils';

export const styles = StyleSheet.create((pd) => ({
  container: {
    overflow: 'visible',
    width: '100%',
    alignSelf: 'center',
  },
  stationRowWrapper: {
    position: 'relative',
  },
  stationRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    position: 'relative',
    zIndex: 10,
    minHeight: pd.ref.space.spacing80.px,
    overflow: 'visible',
  },
  stationRowSection: {
    marginBottom: {
      xs: 0,
      md: pd.ref.space.spacing40.px,
    },
  },
  stationRowSectionNoButton: {
    marginBottom: {
      xs: 0,
      md: 0,
    },
  },
  fieldWrapper: {
    flex: 1,
    minWidth: 0,
    position: 'relative',
    zIndex: 0,
  },
  fieldSpacer: {
    width: pd.ref.space.spacing20.px,
  },
  swapOverlay: {
    position: 'absolute',
    zIndex: 2,
    left: '50%',
    top: '50%',
    transform: [
      { translateX: -pd.ref.space.spacing60.px / 2 },
      { translateY: -pd.ref.space.spacing60.px / 2 },
    ],
  },
  swapButton: {
    borderColor: getColor(pd.sys.colour.outline_low),
    backgroundColor: getColor(pd.sys.colour.bg_primary),
    height: pd.ref.space.spacing60.px,
    width: pd.ref.space.spacing60.px,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: pd.ref.space.spacing60.px / 2,
  },
  swapButtonDisabled: {
    backgroundColor: getColor(pd.sys.colour.bg_secondary),
  },
  searchButtonContainer: {
    marginTop: pd.ref.space.spacing40.px,
    zIndex: 1,
  },
  rowDouble: {
    flexDirection: 'row',
    gap: pd.ref.space.spacing40.px,
    marginBottom: pd.ref.space.spacing40.px,
  },
  halfWidth: {
    flex: 1,
  },
  skeletonFull: {
    width: '100%',
    height: pd.ref.space.spacing80.px,
    backgroundColor: pd.ref.palette.neutral5,
    borderRadius: pd.ref.space.spacing20.px,
  },
  skeletonHalf: {
    width: '100%',
    height: pd.ref.space.spacing80.px,
    backgroundColor: pd.ref.palette.neutral5,
    borderRadius: pd.ref.space.spacing20.px,
  },
  sheetHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: pd.ref.space.spacing40.px,
    paddingTop: pd.ref.space.spacing40.px,
    paddingBottom: 0,
    gap: pd.ref.space.spacing20.px,
    minHeight: 64,
  },
  sheetCloseButton: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sheetInputWrapper: {
    flex: 1,
    minHeight: 48,
  },
  sheetListContainer: {
    flex: 1,
    paddingTop: pd.ref.space.spacing20.px,
  },
  noResultsDropdownContainer: {
    justifyContent: 'center',
    alignItems: 'stretch',
    paddingTop: 0,
    paddingBottom: 0,
  },
  dropdownContainerTopGap: {
    paddingTop: pd.ref.space.spacing20.px,
  },
  stationResultsTopGap: {
    paddingTop: pd.ref.space.spacing40.px,
  },
  searchHeaderPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  noResultsSheetContainer: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    paddingTop: pd.ref.space.spacing80.px,
  },
  noResultsSheetTextContainer: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: pd.ref.space.spacing10.px,
  },
}));
